import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor(private http:HttpClient) { }


  GetCustomerDashboard():Observable<any>{
    return this.http.get(environment.BaseUrl+ "Daro/Dashboard/GetCustomerDashboard").pipe(
      map(data=>{
        return data as any
      })
    )
  }

  GetExpertDashboard(Type:number):Observable<any>{
    return this.http.get(environment.BaseUrl+ "Daro/Dashboard/GetExpertDashboard?Type="+Type).pipe(
      map(data=>{
        return data as any
      })
    )
  }

  GetSuggest():Observable<any>{
    return this.http.get(environment.BaseUrl+ "Daro/Dashboard/GetSuggest").pipe(
      map(data=>{
        return data as any
      })
    )
  }

}
